import moment from "moment";
import React from "react";
import HSGTabs from "../../Containers/HSGTabs";

const RenderYearTab = ({ program, history, changeTab }) => {
  let tabs = [];

  let getLabel = (createdTime, duration) => {
    if (createdTime && duration) {
      let startDate = moment(createdTime).format("MMMM YY"); // Full month name
      let durationObj = moment.duration(Number(12), "months"); // Use passed duration
      let endDate = moment(createdTime).add(durationObj).format("YY"); // Just the year (last two digits)

      // Format like "August 25-26"
      return `${startDate.split(" ")[0]} ${
        startDate.split(" ")[1]
      } - ${endDate}`;
    } else {
      return null;
    }
  };

  tabs =
    history &&
    history?.length &&
    history?.map((programNode) => {
      let label = getLabel(
        programNode.billing.inBillingStartDate,
        programNode.billing.agreement_duration,
      );

      return {
        nav: programNode.billing.id,
        label: label,
        badge: 0,
      };
    });

  let activeTab = program && program.billing ? program.billing.id : null;

  return (
    <HSGTabs
      selected={activeTab}
      changeTab={(index, nav) => changeTab(nav, "year")}
    >
      {tabs &&
        tabs?.map((tab, i) => {
          return (
            <div
              key={i}
              nav={tab.nav}
              label={tab.label}
              badge={tab.badge}
            ></div>
          );
        })}
    </HSGTabs>
  );
};

export default RenderYearTab;
